import './index.scss';
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

window.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('div.swiper.swiper-page-navigation', {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: 'div.swiper-buttons div.button-next',
            prevEl: 'div.swiper-buttons div.button-prev',
        },

        breakpoints: {
            767: {
                slidesPerView: 2,
            }
        }
    }); 
})
